import { Component, OnInit } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { DevToolsService, DevToolsStatus } from './dev-tools.service';
import { AuthService } from '../../../services/auth.service';
import { DevImpersonationState } from '../../../models/user-profile.model';

@Component({
  selector: 'app-dev-tools-button',
  templateUrl: './dev-tools-button.component.html',
})
export class DevToolsButtonComponent implements OnInit {
  isAvailable = false;
  isPanelOpen = false;
  status: DevToolsStatus | null = null;

  overlayPositions: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 8 },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
  ];

  constructor(
    private devToolsService: DevToolsService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.devToolsService.loadStatus().subscribe({
      next: status => {
        this.status = status;
        this.isAvailable = status.available;
      },
      error: () => {
        this.isAvailable = false;
      },
    });
  }

  togglePanel(): void {
    this.isPanelOpen = !this.isPanelOpen;
  }

  closePanel(): void {
    this.isPanelOpen = false;
  }

  /** Substitution d'identité active, telle que renvoyée par /me. */
  get impersonation(): DevImpersonationState | null {
    return this.authService.currentUserValue()?.devImpersonation ?? null;
  }

  getTooltip(): string {
    const target = this.impersonation?.targetProfile;
    return target ? `Dev Tools — connecté en tant que ${target.firstName} ${target.lastName}` : 'Dev Tools';
  }

  /** Badge : l'identité substituée prime sur l'environnement, qui reste lisible dans le panneau. */
  getBadgeLabel(): string {
    const target = this.impersonation?.targetProfile;
    if (target) return `${target.firstName.charAt(0)}. ${target.lastName}`.slice(0, 14);
    return this.getEnvLabel();
  }

  getBadgeColor(): string {
    return this.impersonation ? '#ff9800' : this.getEnvColor();
  }

  getEnvLabel(): string {
    if (!this.status?.activeSnapshot) return 'N/A';
    if (this.status.activeEnvironment) return this.status.activeEnvironment;
    return this.status.activeSnapshot;
  }

  getEnvColor(): string {
    const env = this.status?.activeEnvironment;
    const colorMap: Record<string, string> = {
      staging: '#4caf50',
      preprod: '#2196f3',
      qa: '#9c27b0',
      'prep-qa': '#00bcd4',
      demo: '#795548',
      production: '#f44336',
    };
    return colorMap[env] || '#607d8b';
  }
}
